import { render } from "./requirements.vue?vue&type=template&id=7e52bf9f&scoped=true&lang=pug"
import script from "./requirements.vue?vue&type=script&lang=js"
export * from "./requirements.vue?vue&type=script&lang=js"

import "./requirements.vue?vue&type=style&index=0&id=7e52bf9f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e52bf9f"]])

export default __exports__